var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.buttonArray.length > 0
        ? _c(
            "div",
            { staticClass: "current-con" },
            [
              _c(
                "el-row",
                { staticClass: "current-btn" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    _vm._l(_vm.buttonArray, function (item, index) {
                      return _c(
                        "el-button",
                        {
                          key: index,
                          class: index == _vm.btnIndex ? "is_active" : "",
                          attrs: { round: "" },
                          on: {
                            click: function ($event) {
                              return _vm.handleButton(index, item.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.processIndex !== null
                ? _c(
                    "div",
                    {},
                    [
                      _vm.processIndex == 0
                        ? _c("goalSetting", { attrs: { id: _vm.id } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.processIndex == 1 && !_vm.loading
                        ? _c("execution", {
                            ref: "execution",
                            attrs: {
                              id: _vm.id,
                              processIndex: _vm.processIndex,
                              reply: _vm.reply,
                              "current-button": true,
                            },
                            on: { handleExecution: _vm.handleExecution },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c("default-page", { attrs: { index: 0 } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }